<template>
  <div class="canned-rate-table">
    <b-col class="canned-select-container">
      <label class="canned-select-container__label" for="rate-table"
        >Rate Trip {{ rateTableId + 1 }}</label
      >
    </b-col>
    <div class="open-modal-button-container">
      <a class="open-modal-label" @click="openTable('rate')">Show table</a>
    </div>
    <b-modal
      no-close-on-backdrop
      hide-header-close
      hide-footer
      static
      size="lg"
      :id="'drayage-rate-table-modal' + rateTableId"
      class="rate-modal"
      title="Rate"
      :ref="'drayage-rate-table-modal' + rateTableId"
    >
      <Searcher
        :id="'drayage-rate-table' + rateTableId"
        :fields="rateFields"
        :data="rateTableContent"
        addRows
        deleteRows
        :tableStyles="tableStyles"
        :ref="'horizontal-table' + rateTableId"
        :key="renderTable"
      >
        <template #table-header>
          <tr name="table-fields">
            <th :style="tableStyles.header" :colspan="6">
              Rate Trip {{ rateTableId + 1 }}
            </th>
          </tr>
        </template>

        <template #key="slotProps">
          <input
            v-model="slotProps.row.key"
            class="table-canned__tableField"
            type="text"
            cell-type="editable-cell"
          />
        </template>

        <!-- Rate con el signo pesos -->
        <!-- <template #value="slotProps">
          <input
            v-if="!slotProps.row.key.includes('Rate')"
            v-model="slotProps.row.value"
            class="table-canned__tableField"
            cell-type="editable-cell"
            :type="slotProps.row.inputType"
          />
          <input
            v-else
            v-model="rateValue"
            class="table-canned__tableField"
            cell-type="editable-cell"
            type="text"
            @change="setRate"
          />
        </template> -->

        <template #value="slotProps">
          <input
            v-if="
              !slotProps.row.key.includes('Rate') &&
                !slotProps.row.key.includes('Tarifa')
            "
            v-model="slotProps.row.value"
            class="table-canned__tableField"
            cell-type="editable-cell"
            type="text"
          />
          <input
            v-else
            v-model="rateValue"
            class="table-canned__tableField"
            cell-type="editable-cell"
            type="number"
          />
        </template>
      </Searcher>
      <div class="custom-modal-footer">
        <b-button
          class="custom-modal-footer__ok-button"
          @click="catchHtmlTable"
        >
          OK
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Searcher from "roachcat-components-library/table";
export default {
  name: "Rate",
  components: {
    Searcher
  },
  props: [
    "cannedResponseTableOptions",
    "cannedResponseSelected",
    "rateTableId",
    "currentCannedResponse",
    "haulId"
  ],
  data() {
    return {
      actualQueue: null,
      cannedTableInfo: null,
      rateTableContent: null,
      rateFields: [],
      tableStyles: {
        table: {
          //Modifica los estilos de la etiqueta “table”
          "border-collapse": "collapse"
        },
        header: {
          //Modifica los estilos de las celdas del header que contiene los campos pasados en la propiedad “fields”.
          "background-color": "rgb(230, 230, 250)",
          border: "1px solid rgb(230, 230, 250)",
          "font-size": "13px",
          padding: "4px 8px"
        },
        th: {
          //Modificar los estilos de cada una de las celdas de la información
          "background-color": "rgb(239, 239, 239)",
          "line-height": "10px",
          border: "1px solid rgb(230, 230, 250)",
          "font-size": "12px"
        }
      },
      renderTable: 0,
      htmlTable: null,
      rateValue: null,
      rateNumber: null
    };
  },
  computed: {
    ...mapGetters("quotes/quote", ["showSalePrice"])
  },
  created() {
    this.actualQueue = localStorage.getItem("actual-queue");
    if (this.currentCannedResponse) {
      const arrayRow = Object.keys(
        this.currentCannedResponse?.table_content[0]
      );
      for (let i = 0; i < arrayRow.length; i += 1) {
        if (arrayRow[i] !== "actions") {
          this.rateFields.push({
            label: "",
            propName: arrayRow[i]
          });
        }
      }
    }
    this.getInfoTable();
  },
  mounted() {
    this.setHtmlTable();
  },
  methods: {
    getInfoTable() {
      this.cannedTableInfo = this.currentCannedResponse?.table_content;
      if (this.cannedTableInfo) {
        this.rateTableContent = this.cannedTableInfo;
      }
      // this.rateTableContent[0][
      //   "Linehaul Rate + FSC (included)"
      // ] = this.enterSalePriceValue();
      this.rateValue = this.enterSalePriceValue();
      this.updateRate();
      // Rate con el signo pesos
      // this.setRate();
    },
    openTable() {
      this.$refs[`drayage-rate-table-modal${this.rateTableId}`].show();
    },
    catchHtmlTable() {
      this.$refs[`drayage-rate-table-modal${this.rateTableId}`].hide();
      this.setHtmlTable();
    },
    setHtmlTable() {
      this.htmlTable = this.$refs[
        `horizontal-table${this.rateTableId}`
      ].getTableHtml();
      this.updateRate();
      // Rate con el signo pesos
      // this.setRate();
      this.htmlTable = this.htmlTable.outerHTML;
      let tableInfo = {};
      tableInfo.tableType = "rate";
      tableInfo.tableId = `{table_rate_${this.rateTableId + 1}}`;
      tableInfo.htmlTable = this.htmlTable;
      this.$emit("cannedResponseTable", tableInfo);
    },
    updateRate() {
      if (this.rateValue) {
        this.$store.commit("cannedResponsesModule/setRate", {
          tripNumber: this.haulId,
          rate_usd: this.rateValue
        });
      } else {
        this.$store.commit("cannedResponsesModule/setRate", {
          tripNumber: this.haulId,
          rate_usd: null
        });
      }
    },
    // Rate con el signo pesos
    /* setRate() {
      const validationRate = /^[$]+[0-9]+$/;
      if (this.rateValue?.match(validationRate)) {
        this.getOnlyNumbers();
      } else {
        this.rateValue = "$";
        this.rateNumber = null;
      }
    }, */
    enterSalePriceValue() {
      if (this.showSalePrice) {
        return this.showSalePrice;
        // Rate con el signo pesos
        // return "$" + this.showSalePrice[this.haulId];
      }
      return null;
      // Rate con el signo pesos
      // return "$";
    }
    // Rate con el signo pesos
    /* getOnlyNumbers() {
      if (this.rateValue.includes("$")) {
        this.rateNumber = this.rateValue;
        const symbolIndex = this.rateNumber?.indexOf("$");
        this.rateNumber = Number(this.rateNumber?.slice(symbolIndex + 1));
        this.updateRate();
      }
    } */
  }
};
</script>

<style lang="scss" scoped>
.canned-rate-table {
  @extend %canned-tables;
}
::v-deep .table-component {
  padding: 0 1rem;
}
.open-modal-label {
  &:hover {
    cursor: pointer;
  }
}
::v-deep .button-toolbar {
  margin-bottom: 1rem;
  display: flex;
  justify-content: start;
  &__button {
    @include secondary-button;
  }
}
::v-deep .table td {
  font-size: 13px;
  padding: 0;
  border: 1px solid rgb(230, 230, 250);
}
::v-deep .table__delete-button {
  & button {
    border-radius: 0.25rem;
  }
}
.table-canned {
  &__tableField {
    display: inline-block;
    border: none;
    min-width: 100px;
    width: 100%;
    height: 28px;
    &:focus {
      outline: none;
    }
  }
}

.rate-table-footer {
  margin-top: 10px;
  text-align: left;
  &__note {
    font-weight: bold;
    margin-bottom: 0px;
    &--upper-footer {
      background-color: yellow;
    }
  }
}
</style>
